module.exports = __webpack_public_path__ + "img/gko.10d08fc4.png";